/* src/app/components/upload-file-popover/upload-file-popover.component.scss */
svg {
  width: 25px;
  margin-right: 10px;
}
/*# sourceMappingURL=upload-file-popover.component-Y46LAVS4.css.map */
